<template>
  <div>
    <HeroSection
      :nav-breadcrumbs="[
        {
          href: '/training',
          title: 'Training'
        },
        {
          href: '/training/workshops',
          title: 'Workshops'
        }
      ]"
      :value="workshopsPage.hero_section"
    >
      <template v-if="workshopsPage.hero_section.cta" #cta>
        <HeroCta :value="workshopsPage.hero_section.cta" />
      </template>
    </HeroSection>

    <TrainingDifferentiatorsSection
      :scroll-to-section="scrollToSection"
      :value="workshopsPage.training_differentiators_section"
      class="mb-16 hero-section hero-below-offset"
    />

    <LogoBarSection
      :items="logos"
      :value="workshopsPage.logo_bar_section"
      class="mb-16"
    />

    <ProductsOverviewSection
      :items="workshops"
      :learn-href="item => `/training/workshops/${slugify(item)}`"
      :schedule-href="
        item => `/training/schedule?what=${item.code.toLowerCase()}`
      "
      :value="workshopsPage.products_overview_section"
    />

    <CrossSellSection
      :value="workshopsPage.cross_sell_section"
      boxed
      outlined
      class="mb-8"
    />

    <v-container
      :ref="
        el => {
          sectionRefs.register = el
        }
      "
    />

    <v-lazy>
      <OccasionsSection
        :banner="banner"
        :filters-value="{ occasionType: 'W' }"
        :value="workshopsPage.classes_section"
        :what-menu="whatMenu"
        class="mb-16"
      />
    </v-lazy>

    <ReviewsSection :items="reviews" class="mb-16" />

    <ServicesSection :value="workshopsPage.services_section" class="mb-16" />

    <DividerSection class="mb-16" />

    <ContactCtaSection
      :value="workshopsPage.contact_cta_section"
      class="mb-16"
    />
  </div>
</template>

<script setup lang="ts">
import { reactive } from 'vue'
import { useProvideDeliveryMethodsStore } from '#root/lib/useDeliveryMethodsStore'
import { useProvideTrainerPersonsStore } from '#root/lib/useTrainerPersonsStore'
import { scrollToRefKey, slugify } from '#root/lib/utils'

const sectionRefs = reactive({})

const props = defineProps({
  banner: {
    default: undefined,
    type: Object
  },
  deliveryMethods: {
    required: true,
    type: Array
  },
  logos: {
    required: true,
    type: Array
  },
  reviews: {
    required: true,
    type: Array
  },
  trainers: {
    required: true,
    type: Array
  },
  whatMenu: {
    required: true,
    type: Object
  },
  workshops: {
    required: true,
    type: Array
  },
  workshopsPage: {
    required: true,
    type: Object
  }
})

useProvideDeliveryMethodsStore(props.deliveryMethods)
useProvideTrainerPersonsStore(props.trainers)

function scrollToSection({ key }) {
  scrollToRefKey(sectionRefs, key)
}
</script>
